(() => {
  // SOILL-CUSTOM [NAV-001]
  // Initialize Flex mega menus before window.load and add keyboard/ARIA behavior.
  const desktopNavigation = window.matchMedia('(min-width: 799px)');

  const findDirectChild = (parent, predicate) => (
    Array.prototype.find.call(parent.children, predicate)
  );

  const findTrigger = (parent) => {
    const label = findDirectChild(parent, (child) => child.tagName === 'LABEL');
    if (label) return label.querySelector('.header__link');

    return findDirectChild(parent, (child) => child.classList.contains('header__link'));
  };

  const setExpandedState = (parent, expanded) => {
    const trigger = findTrigger(parent);
    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  };

  const enhanceMegaMenuAccessibility = () => {
    document.querySelectorAll('.navbar-item.has-mega-menu').forEach((parent, index) => {
      const menuSection = findDirectChild(
        parent,
        (child) => child.classList.contains('mega-menu__section'),
      );
      const trigger = findTrigger(parent);

      if (!menuSection || !trigger) return;

      if (!menuSection.id) {
        const handle = parent.dataset.navlinkHandle || `menu-${index}`;
        const context = parent.closest('.sticky-header__menu') ? 'sticky' : 'primary';
        menuSection.id = `mega-menu-${context}-${handle}-${index}`;
      }

      parent.removeAttribute('aria-haspopup');
      parent.removeAttribute('aria-expanded');
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-controls', menuSection.id);
      setExpandedState(parent, menuSection.classList.contains('is-active'));

      if (parent.dataset.soillMegaAccessibilityBound === 'true') return;
      parent.dataset.soillMegaAccessibilityBound = 'true';

      const observer = new MutationObserver(() => {
        setExpandedState(parent, menuSection.classList.contains('is-active'));
      });
      observer.observe(menuSection, { attributes: true, attributeFilter: ['class'] });

      parent.addEventListener('focusin', () => {
        if (!desktopNavigation.matches) return;

        document.querySelectorAll('.mega-menu__section.is-active').forEach((openMenu) => {
          if (openMenu !== menuSection) openMenu.classList.remove('is-active');
        });
        menuSection.classList.add('is-active');
      });

      parent.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!parent.contains(document.activeElement)) {
            menuSection.classList.remove('is-active');
          }
        });
      });

      parent.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        menuSection.classList.remove('is-active');
        trigger.focus();
      });
    });
  };

  const initializeMegaMenus = () => {
    if (!window.jQuery || !window.PXUTheme || !window.PXUTheme.jsMegaMenu) return false;

    const sections = document.querySelectorAll('.shopify-section.jsMegaMenu');
    if (!sections.length) return true;

    if (window.performance && typeof window.performance.mark === 'function') {
      window.performance.mark('soill-mega-menu-init-start');
    }

    sections.forEach((section) => {
      if (section.dataset.soillMegaInitialized === 'true') return;

      window.PXUTheme.jsMegaMenu.init(window.jQuery(section));
      section.dataset.soillMegaInitialized = 'true';
    });

    document.documentElement.classList.add('soill-mega-menu-ready');
    enhanceMegaMenuAccessibility();
    if (window.performance && typeof window.performance.mark === 'function') {
      window.performance.mark('soill-mega-menu-init-end');
    }
    if (window.performance && typeof window.performance.measure === 'function') {
      window.performance.measure(
        'soill-mega-menu-init',
        'soill-mega-menu-init-start',
        'soill-mega-menu-init-end',
      );
    }

    return true;
  };

  const initializeNavigation = () => {
    if (initializeMegaMenus()) return;

    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (initializeMegaMenus() || attempts >= 40) {
        window.clearInterval(retry);
      }
    }, 50);
  };

  const updateDisclaimerButtons = () => {
    const disclaimer = document.getElementById('mandatory-disclaimer');

    // Do not alter Bold buttons on products that have no required disclaimer.
    if (!disclaimer) return;

    document.querySelectorAll('.bold_clone').forEach((button) => {
      button.style.pointerEvents = disclaimer.checked ? 'all' : 'none';
      button.style.opacity = disclaimer.checked ? '1' : '0.7';
      button.disabled = !disclaimer.checked;
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('#mandatory-disclaimer')) {
      updateDisclaimerButtons();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeNavigation();
      updateDisclaimerButtons();
    });
  } else {
    initializeNavigation();
    updateDisclaimerButtons();
  }

  document.addEventListener('shopify:section:load', () => {
    initializeMegaMenus();
    updateDisclaimerButtons();
  });
})();
